import { configureStore } from "@reduxjs/toolkit";
import activeInjectionsReducer from "./slices/activeInjectionsSlice";
import appSettingsReducer from "./slices/appSettingsSlice";
import categoriesReducer from "./slices/categoriesSlice";
import classificationsReducer from "./slices/classificationsSlice";
import cmsSettingsReducer from "./slices/cmsSettingsSlice";
import configReducer from "./slices/configSlice";
import currentFormReducer from "./slices/currentFormSlice";
import currentPageReducer from "./slices/currentPageSlice";
import fieldsReducer from "./slices/fieldsSlice";
import formDataReducer from "./slices/formDataSlice";
import formSettingsReducer from "./slices/formSettingsSlice";
import internalSettingsReducer from "./slices/internalSettingsSlice";
import existingRegistrationsReducer from "./slices/existingRegistrationsSlice";
import receiptReducer from "./slices/receiptSlice";
import p2pSettingsReducer from "./slices/p2pSettingsSlice";
import parentRegistrationReducer from "./slices/parentRegistrationSlice";
import productModalReducer from "./slices/productModalSlice";
import productSettingsReducer from "./slices/productSettingsSlice";
import productsReducer from "./slices/productsSlice";
import raceConditionsReducer from "./slices/raceConditionsSlice";
import registrationAccountReducer from "./slices/registrationAccountSlice";
import registrationReducer from "./slices/registrationSlice";
import teamsReducer from "./slices/teamsSlice";
import emailVerificationReducer from "./slices/emailVerificationSlice";

const enableDevtools = window.QGIV && window.QGIV.ENABLE_REDUX_DEVTOOLS;

const devTools = enableDevtools
    ? window.__REDUX_DEVTOOLS_EXTENSION__ &&
      window.__REDUX_DEVTOOLS_EXTENSION__()
    : false;

const storeConfigObject = {
    devTools,
    reducer: {
        activeFormInjections: activeInjectionsReducer,
        appSettings: appSettingsReducer,
        categories: categoriesReducer,
        classifications: classificationsReducer,
        cmsSettings: cmsSettingsReducer,
        config: configReducer,
        currentForm: currentFormReducer,
        currentPage: currentPageReducer,
        fields: fieldsReducer,
        formData: formDataReducer,
        formSettings: formSettingsReducer,
        internalSettings: internalSettingsReducer,
        emailVerification: emailVerificationReducer,
        existingRegistrations: existingRegistrationsReducer,
        p2pSettings: p2pSettingsReducer,
        parentRegistration: parentRegistrationReducer,
        productModalState: productModalReducer,
        productSettings: productSettingsReducer,
        products: productsReducer,
        raceConditions: raceConditionsReducer,
        receipts: receiptReducer,
        registrationAccount: registrationAccountReducer,
        registration: registrationReducer,
        teams: teamsReducer,
    },
};

export default configureStore({
    ...storeConfigObject,
});
